import { motion } from "framer-motion";

export default function Process({ steps }) {
  return (
    <section id="process" className="relative py-24 sm:py-32" data-testid="process-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="mb-14"
        >
          <p className="font-mono text-xs uppercase tracking-[0.3em] text-gold mb-4">The DRC502 standard</p>
          <h2 className="font-display font-bold italic uppercase text-4xl sm:text-5xl lg:text-6xl text-white leading-[0.95]" data-testid="process-heading">
            Four steps. <span className="gold-text">Zero surprises.</span>
          </h2>
        </motion.div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-px bg-gold/10 border border-gold/10 rounded-2xl overflow-hidden">
          {(steps || []).map((p, i) => (
            <motion.div
              key={p.num || i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: i * 0.1 }}
              className="relative bg-storm p-8 group hover:bg-storm-800 transition-colors"
              data-testid={`process-step-${i}`}
            >
              <div className="font-display font-bold text-6xl text-stroke-gold leading-none mb-6 select-none">{p.num}</div>
              <h3 className="font-display font-bold uppercase italic text-2xl text-white group-hover:text-gold transition-colors">{p.title}</h3>
              <p className="mt-3 text-sm text-slate-400 leading-relaxed">{p.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
